import React, { FC } from 'react';
import { Drag } from '@firesoon/icons-react';
import classnames from 'classnames';
import { DragItemProps } from '../interface';
import './index.less';

const DragItem: FC<DragItemProps> = (props) => {
  const { provided, style, children, className, icon = true } = props;
  return (
    <div
      className={classnames('fs-drag-drop-item', className)}
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      ref={provided?.innerRef}
      style={{ ...style, ...provided?.draggableProps.style }}
    >
      <div className="fs-drag-drop-item-wrap">
        {(() => {
          if (icon === false) {
            return null;
          }
          if (icon === true) {
            return <Drag />;
          }
          // @ts-ignore
          return React.cloneElement(icon);
        })()}
        {React.cloneElement(React.Children.only(children) as React.ReactElement, {
          className: 'fs-drag-drop-item-children',
        })}
      </div>
    </div>
  );
};

export default DragItem;
